import { PageConfigModel } from "../types/Config";
import { PageKey } from "../types/strapi/PageConfig";

export function getPageConfigField(pageKey: PageKey, fieldName: string) {
  try {
    const pageConfigData = sessionStorage.getItem("pageConfigs");
    if (!pageConfigData) return undefined;

    const pageConfigs = JSON.parse(pageConfigData);

    const matchedPage = pageConfigs.find(
      (item: any) => item.pageKey === pageKey
    );
    return matchedPage?.config?.[fieldName];
  } catch (e) {
    console.error("Error parsing pageConfig from sessionStorage", e);
    return undefined;
  }
}

export function getPartnerConfigField(fieldName: string) {
  try {
    const partnerConfigData = sessionStorage.getItem("partnerConfig");
    if (!partnerConfigData) return undefined;

    const partnerConfigs = JSON.parse(partnerConfigData);

    return partnerConfigs?.[fieldName];
  } catch (e) {
    console.error("Error parsing partnerConfig from sessionStorage", e);
    return undefined;
  }
}

export function getPageConfigByPageKey(pageKey: PageKey) {
  try {
    const pageConfigData = sessionStorage.getItem("pageConfigs");
    if (!pageConfigData) return undefined;

    const pageConfigs = JSON.parse(pageConfigData) as PageConfigModel[];

    return pageConfigs.find((item) => item.pageKey === pageKey);
  } catch (e) {
    console.error(
      "getPageConfigs: Error parsing pageConfig from sessionStorage",
      e
    );
    return undefined;
  }
}
